<h1 mat-dialog-title>Demande de confirmation</h1>
<div mat-dialog-content>
  <p>Vous allez quitter un document en cours de modification. <br />Les données modifiées seront définitivenent perdus.</p>
  <p>Voulez-vous quitter cette page ?</p>
</div>

<div mat-dialog-actions align="end">
  <button mat-raised-button (click)="ignore()">Continer</button>
  <button mat-raised-button (click)="resume()">Annuler</button>
</div>
